import { Table, Database } from './lib/Database';
import type { DatabaseRecord, WhereCallback } from './@types/Database';

export default Database;
export { 
    Table, 
    Database,
    type DatabaseRecord,
    type WhereCallback
};